import { LightingSolution, LightingSolutionCategory, NextArray } from 'type';

const filterWithCategory = (
  lightingSolutions: NextArray<LightingSolution>,
  category: LightingSolutionCategory
) =>
  lightingSolutions.filter(
    (lightingSolution) => lightingSolution.category === category
  );

const getWithSlug = (
  lightingSolutions: NextArray<LightingSolution>,
  slug?: string
) =>
  lightingSolutions.find(
    (lightingSolution) => lightingSolution.slug.current === slug
  );

export const LightingSolutionUtil = {
  filterWithCategory,
  getWithSlug,
};
